import { PublicKey } from '@solana/web3.js';

// Metaplex Token Metadata Program ID
export const TOKEN_METADATA_PROGRAM_ID = new PublicKey(
  'metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s',
);

/**
 * Derive collection metadata PDA
 * Seeds: ["metadata", TOKEN_METADATA_PROGRAM_ID, collection_mint]
 */
export function getCollectionMetadataPDA(
  collectionMint: PublicKey,
): PublicKey {
  const [metadata] = PublicKey.findProgramAddressSync(
    [
      Buffer.from('metadata'),
      TOKEN_METADATA_PROGRAM_ID.toBuffer(),
      collectionMint.toBuffer(),
    ],
    TOKEN_METADATA_PROGRAM_ID,
  );
  return metadata;
}

/**
 * Derive collection master edition PDA
 * Seeds: ["metadata", TOKEN_METADATA_PROGRAM_ID, collection_mint, "edition"]
 */
export function getCollectionMasterEditionPDA(
  collectionMint: PublicKey,
): PublicKey {
  const [masterEdition] = PublicKey.findProgramAddressSync(
    [
      Buffer.from('metadata'),
      TOKEN_METADATA_PROGRAM_ID.toBuffer(),
      collectionMint.toBuffer(),
      Buffer.from('edition'),
    ],
    TOKEN_METADATA_PROGRAM_ID,
  );
  return masterEdition;
}

/**
 * Derive collection authority record PDA
 * Seeds: ["metadata", TOKEN_METADATA_PROGRAM_ID, collection_mint, "collection_authority", new_authority]
 */
export function getCollectionAuthorityRecordPDA(
  collectionMint: PublicKey,
  newAuthority: PublicKey,
): PublicKey {
  const [authorityRecord] = PublicKey.findProgramAddressSync(
    [
      Buffer.from('metadata'),
      TOKEN_METADATA_PROGRAM_ID.toBuffer(),
      collectionMint.toBuffer(),
      Buffer.from('collection_authority'),
      newAuthority.toBuffer(),
    ],
    TOKEN_METADATA_PROGRAM_ID,
  );
  return authorityRecord;
}

/**
 * Derive NFT metadata PDA
 * Seeds: ["metadata", TOKEN_METADATA_PROGRAM_ID, nft_mint]
 */
export function getNFTMetadataPDA(nftMint: PublicKey): PublicKey {
  const [metadata] = PublicKey.findProgramAddressSync(
    [
      Buffer.from('metadata'),
      TOKEN_METADATA_PROGRAM_ID.toBuffer(),
      nftMint.toBuffer(),
    ],
    TOKEN_METADATA_PROGRAM_ID,
  );
  return metadata;
}

/**
 * Derive NFT master edition PDA
 * Seeds: ["metadata", TOKEN_METADATA_PROGRAM_ID, nft_mint, "edition"]
 */
export function getNFTMasterEditionPDA(nftMint: PublicKey): PublicKey {
  const [masterEdition] = PublicKey.findProgramAddressSync(
    [
      Buffer.from('metadata'),
      TOKEN_METADATA_PROGRAM_ID.toBuffer(),
      nftMint.toBuffer(),
      Buffer.from('edition'),
    ],
    TOKEN_METADATA_PROGRAM_ID,
  );
  return masterEdition;
}

